import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Enter a valid email");
    toast.success("Welcome to the Archive");
    setEmail("");
  };
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-[#0A0A0C]">
      <div className="px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-5">
          <p className="font-display font-extrabold tracking-tighter uppercase text-2xl">
            Noir<span className="text-[#FF334B]">/</span>Archive
          </p>
          <p className="text-zinc-500 text-sm mt-4 max-w-sm leading-relaxed">
            Dispatch notes, archive drops and private previews. One email a month, never more.
          </p>
          <form onSubmit={submit} className="mt-6 flex max-w-sm" data-testid="newsletter-form">
            <input
              data-testid="newsletter-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="EMAIL ADDRESS"
              className="flex-1 bg-transparent border border-zinc-700 px-4 py-3 mono text-xs tracking-[0.2em] placeholder:text-zinc-600 focus:outline-none focus:border-[#FF334B]"
            />
            <button
              data-testid="newsletter-submit-button"
              className="bg-[#FF334B] text-white mono text-xs tracking-[0.2em] px-5 hover:bg-[#d92339] transition-colors"
            >
              JOIN
            </button>
          </form>
        </div>
        <div className="col-span-6 lg:col-span-3">
          <p className="mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">Store</p>
          <div className="flex flex-col gap-3 text-sm text-zinc-400">
            <Link data-testid="footer-shop-link" to="/shop" className="hover:text-[#FF334B] transition-colors">Catalog</Link>
            <Link data-testid="footer-orders-link" to="/orders" className="hover:text-[#FF334B] transition-colors">Order Lookup</Link>
            <Link data-testid="footer-refunds-link" to="/refunds" className="hover:text-[#FF334B] transition-colors">Refunds & Returns</Link>
          </div>
        </div>
        <div className="col-span-6 lg:col-span-4">
          <p className="mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-5">Follow</p>
          <div className="flex gap-4">
            <a data-testid="social-instagram-link" href="https://instagram.com" target="_blank" rel="noreferrer" className="border border-zinc-700 p-3 hover:border-[#FF334B] hover:text-[#FF334B] transition-colors"><Instagram size={16} /></a>
            <a data-testid="social-twitter-link" href="https://twitter.com" target="_blank" rel="noreferrer" className="border border-zinc-700 p-3 hover:border-[#FF334B] hover:text-[#FF334B] transition-colors"><Twitter size={16} /></a>
            <a data-testid="social-youtube-link" href="https://youtube.com" target="_blank" rel="noreferrer" className="border border-zinc-700 p-3 hover:border-[#FF334B] hover:text-[#FF334B] transition-colors"><Youtube size={16} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-zinc-900 px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row justify-between gap-2">
        <p className="mono text-[10px] tracking-[0.25em] text-zinc-600 uppercase">© 2026 Noir Archive. All rights reserved.</p>
        <p className="mono text-[10px] tracking-[0.25em] text-zinc-600 uppercase">Edition 2026 — Defining the new silhouette</p>
      </div>
    </footer>
  );
}
